<template>
    <div>
        <el-form label-width="100px">
            <el-form-item label="选择小程序:" prop="pass">
                <el-select v-model="appIdValue" placeholder="请选择">
                    <el-option label="穿衣助手" value="1"></el-option>
                    <el-option label="ICY" value="3"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="商品ID:" prop="pass">
                <el-input v-model="goodsId" style="width: 200px;"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="onDownload">确认下载</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>
<script type="text/babel">
export default {
  components: {},
  data () {
	  return {
	    appIdValue: '',
      goodsId: ''
    }
  },
  methods: {
	  onDownload () {
	    if (!this.appIdValue || !this.goodsId) {
	      this.$message('请选择小程序或者输入商品ID!')
        return false
      }
      let params = {
		  appIdValue: this.appIdValue,
		  goodsId: this.goodsId
      }
      HttpRequest.get('/admin.php?method=weixin.getGoodsPageQrCode', params).then(response => {
        window.open(process.env.VUE_APP_IMGCDN + response.data.image)
      })
    }
  }
}
</script>
<style lang="less" scoped>

</style>
